export default "__VITE_ASSET__HtMe_CyJ__"